import "./Persons.html";
import "./Persons.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import PersonsComponentController from "./PersonsComponentController";

export class PersonsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = PersonsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Persons/Persons.html";
    }
}

module("mmManagePortal").component("mmSitePersons", new PersonsComponent());
